module.exports = __webpack_public_path__ + "assets/img/38.01a283a0.png";